import { Link } from "react-router-dom";
import { getCategoryLabel, getUnitLabel, fileUrl } from "../../lib/api";
import { useI18n } from "../../i18n/I18nProvider";
import { Plus, Trash2 } from "lucide-react";

export default function SellerListings({ listings, onDelete }) {
  const { t, lang } = useI18n();

  if (listings.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="label-tech">{t("dash.emptyInventory")}</div>
        <h3 className="font-display text-2xl mt-2">{t("dash.noListings")}</h3>
        <Link to="/listings/new" className="btn-primary mt-6 inline-flex" data-testid="empty-new-listing-btn">
          <Plus size={14} /> {t("dash.postFirst")}
        </Link>
      </div>
    );
  }

  return (
    <div className="divide-y divide-[var(--ink-200)]">
      {listings.map((l) => (
        <div key={l.id} className="py-4 flex items-center gap-4">
          <div className="w-20 h-20 bg-[var(--surface-alt)] flex-shrink-0">
            {l.image_paths?.[0] && <img src={fileUrl(l.image_paths[0])} alt="" className="w-full h-full object-cover" />}
          </div>
          <div className="flex-1">
            <Link to={`/listings/${l.id}`} className="font-display text-lg hover:underline">{l.title}</Link>
            <div className="text-sm text-[var(--ink-700)] mt-1 flex flex-wrap gap-3">
              <span>{getCategoryLabel(l.category, lang)}</span>
              <span>{l.quantity} {getUnitLabel(l.unit, lang)}</span>
              <span>{l.location}</span>
              <span className="tag tag-moss">{l.quality}</span>
            </div>
          </div>
          <button onClick={() => onDelete(l.id)} className="btn-ghost" data-testid={`delete-listing-${l.id}`}>
            <Trash2 size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
